import ARMLib from 'arm-vue-lib'

export default {
  mixins: [ARMLib._mixins.GraphQLForm],
  data: function() {
    return {
      requestSubject: '',
      requestMessage: ''
    }
  },
  computed: {
    myPersonId() {
      return parseInt(this.$store.state.personId)
    },
    sendEmailMutation() {
      return this.buildGraphqlMutation(
        'sendEmail',
        [
          {
            field: 'to',
            required: true
          },
          {
            field: 'subject',
            required: true
          },
          'message'
        ],
        [],
        {
          mutationName: 'sendEmailMutation'
        }
      )
    }
  },
  methods: {
    conditionMatches(condition, data) {
      if (!condition || !condition.field) {
        return false
      }

      const fieldValue = data[condition.field]
      if (Object.prototype.hasOwnProperty.call(condition, 'value')) {
        if (Array.isArray(condition.value)) {
          return condition.value.includes(fieldValue)
        }
        return fieldValue === condition.value
      }

      return Boolean(fieldValue)
    },
    shouldRenderField(field, data) {
      if (!field || Array.isArray(field) || typeof field !== 'object') {
        return true
      }

      const hasShowIf =
        field.showIf && typeof field.showIf == 'object' && field.showIf.field
      const hasHideIf =
        field.hideIf && typeof field.hideIf == 'object' && field.hideIf.field

      if (hasShowIf && !this.conditionMatches(field.showIf, data)) {
        return false
      }
      if (hasHideIf && this.conditionMatches(field.hideIf, data)) {
        return false
      }

      return true
    },
    buildFieldMessage(
      field,
      data,
      refName = 'formEdit',
      emittedFieldNames = null
    ) {
      let returnMessage = ''
      if (!this.shouldRenderField(field, data)) {
        return returnMessage
      }

      if (field.type == 'group') {
        let groupMessage = ''
        for (let subField of field.fields) {
          groupMessage += this.buildFieldMessage(
            subField,
            data,
            refName,
            emittedFieldNames
          )
        }
        if (groupMessage != '') {
          returnMessage += `${field.label ? '\n' : ''}${field.label || ''}${
            field.label ? ':\n' : ''
          }${groupMessage}${field.label ? '\n' : ''}`
        }
      } else if (Array.isArray(field)) {
        for (let subField of field) {
          returnMessage += this.buildFieldMessage(
            subField,
            data,
            refName,
            emittedFieldNames
          )
        }
      } else if (field.type == 'results') {
        if (
          data[field.name] &&
          data[field.name].filter(record => record.selected).length
        ) {
          returnMessage += field.selectedMessage
            ? `${field.selectedMessage}\n`
            : `Remove ${this.getLabel(field)}:\n`
          for (let record of data[field.name].filter(
            record => record.selected
          )) {
            for (let subField of field.fields.filter(sf => sf.required)) {
              returnMessage += `${this.getLabel(subField)}: ${
                record[subField.key || subField]
              } `
            }
            returnMessage += '\n'
          }
          returnMessage += '\n'
        }
      } else if (field.type == 'graphql_form_search_multi') {
        if (data[field.name] && data[field.name].length) {
          returnMessage += `${this.getLabel(field)}:\n`
          for (let record of data[field.name]) {
            for (let subField of field.fields.filter(
              field => field.key != 'remove'
            )) {
              returnMessage += `${this.getLabel(subField)}: ${
                subField.key == 'selected'
                  ? record.selected
                    ? 'Yes'
                    : 'No'
                  : record[subField.key || subField]
              } `
            }
            returnMessage += '\n'
          }
          returnMessage += '\n'
        }
      } else if (this.$refs[refName].formData[field.name] != data[field.name]) {
        returnMessage += `${this.getLabel(field)}: `
        if (field.type == 'select') {
          returnMessage +=
            (
              this.getOptions(field).find(
                option => option.value == data[field.name]
              ) || {}
            ).text ||
            data[field.name] ||
            ''
        } else if (field.type == 'checkbox') {
          returnMessage += data[field.name] ? 'Yes' : 'No'
        } else if (field.type == 'textarea') {
          returnMessage += `\n${data[field.name]}\n`
        } else {
          returnMessage += data[field.name]
        }
        returnMessage += '\n'
        if (emittedFieldNames && field.name) {
          emittedFieldNames.add(field.name)
        }
      }
      return returnMessage
    },
    buildRequestMessage(data, refName = 'formEdit') {
      this.requestSubject = ''
      this.requestMessage = ''
      const emittedFieldNames = new Set()
      /*
      for (let field of this.flattenFields(
        this.formTypes[this.reviewTable.formType].form.schema
      )) {
      */
      for (let field of this.formTypes[this.reviewTable.formType].form.schema) {
        this.requestMessage += this.buildFieldMessage(
          field,
          data,
          refName,
          emittedFieldNames
        )
      }

      // Always include core identity fields for ARM staff update requests.
      if (this.reviewTable.formType == 'my_review_new') {
        const identityFields = [
          { name: 'name', label: 'Name' },
          { name: 'email', label: 'Email' },
          { name: 'username', label: 'Username' },
          { name: 'affiliation', label: 'Affiliation' }
        ]

        for (let identityField of identityFields) {
          const value = data[identityField.name]
          if (value === null || value === undefined || value === '') {
            continue
          }

          if (!emittedFieldNames.has(identityField.name)) {
            this.requestMessage += `${identityField.label}: ${value}\n`
            emittedFieldNames.add(identityField.name)
          }
        }
      }
    }
  }
}
